import * as angular from "angular";
import {IController} from "angular";

export class BillingAccountsViewCtrl implements IController {
  public queryString: string;


  submitQuery(queryString) {
    this.queryString = queryString;
  }
}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingAccountsView', {
    bindings: {},
    template: require('./billing-accounts-view.html').default,
    controller: BillingAccountsViewCtrl
  });
